import { mapGetters } from "vuex";

const mixinForward = {
  computed: {
    ...mapGetters(["forward"])
  },
  mounted() {
    const { query, hash, fullPath } = this.$route;
    const { f } = query || {};
    if (f) {
      // 当有hash时，判断hash是否在跳转地址中
      const hasHash =
        hash && decodeURIComponent(fullPath).indexOf(f + hash) > -1;
      this.$store.commit("SET_FORWARD", hasHash ? f + hash : f);
    } else {
      // 重置跳转地址
      this.$store.commit("SET_FORWARD", "");
    }
  },
  methods: {
    /**
     *  操作成功提示
     *
     * @param {String} content 提示文本
     * @param {Object} options 可配置项
     * @param {Boolean=} [options.countdown] 是否开启倒计时读秒提示
     * @param {Function=} [options.callback] 提示回调
     *
     */
    success(content, options) {
      const config = Object.assign({ countdown: false }, options || {});
      if (config.countdown) {
        let second = config.second || 3;
        const toast = this.$Toast.success({
          duration: 0, // 持续展示
          forbidClick: true, // 禁用背景点击
          message: `${content}\n${second}秒后自动跳转`
        });

        const timer = setInterval(() => {
          second--;
          if (second) {
            toast.message = `${content}\n${second}秒后自动跳转`;
          } else {
            clearInterval(timer);
            this.$Toast.clear();
            config.callback && config.callback();
          }
        }, 1000);
      } else {
        this.$Toast.success(content);
        config.callback && config.callback();
      }
    }
  }
};

export { mixinForward };
